import type { FunctionComponent } from "react";
import TickIcon from "../assets/svgs/common/tick.svg";
import ReviewIcon from "../assets/svgs/common/review.svg";
import ClosedIcon from "../assets/svgs/common/closed.svg";
import { InstagramIcon } from "../assets/svgs/common/instagram.svg";
import { Dot, YoutubeIcon } from "lucide-react";
import YTShort from "../assets/svgs/common/yt-short.svg";

export const ActiveBadge: FunctionComponent = () => {
  return (
    <span className="flex items-center gap-1 bg-primarybuttonbg backdrop-blur-sm px-3 py-3 border rounded-full w-fit font-bold text-primarybuttontext text-xs">
      <TickIcon />
      active
    </span>
  );
};

export const ActiveCampaignBadge: FunctionComponent = () => {
  return (
    <span className="flex items-center gap-1 bg-sololightgreen backdrop-blur-sm px-3 py-3 border border-primarybuttonbg border-dashed rounded-full w-fit font-bold text-primarybuttonbg text-xs">
      <TickIcon />
      active
    </span>
  );
};

export const UnderReviewBadge: FunctionComponent = () => {
  return (
    <span
      style={{ background: "rgba(255, 241, 54, 0.08)" }}
      className="flex items-center gap-1 bg-documentsubmissiontext backdrop-blur-sm px-3 py-3 border border-[#FFF136] border-dashed rounded-full w-fit font-bold text-[#FFF136] text-xs"
    >
      <ReviewIcon />
      pending approval
    </span>
  );
};

export const ClosedBadge: FunctionComponent = () => {
  return (
    <span className="flex items-center gap-1 bg-tertiarybuttonbg backdrop-blur-sm px-3 py-3 border border-dashed rounded-full w-fit font-bold text-primary text-xs">
      <ClosedIcon />
      closed
    </span>
  );
};

export const ReelsBadge: FunctionComponent = () => {
  return (
    <span
      style={{
        background:
          "linear-gradient(96deg, rgba(251, 251, 251, 0.14) -113.17%, rgba(251, 251, 251, 0.00) 100%)",
      }}
      className="flex items-center gap-1 backdrop-blur-sm px-3 py-3 border border-border rounded-full w-fit font-bold text-xs"
    >
      <InstagramIcon />
      instagram reels
    </span>
  );
};
export const ShortsBadge: FunctionComponent = () => {
  return (
    <span
      style={{
        background:
          "linear-gradient(96deg, rgba(251, 251, 251, 0.14) -113.17%, rgba(251, 251, 251, 0.00) 100%)",
      }}
      className="flex items-center gap-1 backdrop-blur-sm px-3 py-3 border border-border rounded-full w-fit font-bold text-xs"
    >
      <YTShort className="w-4 h-4" />
      Youtube shorts
    </span>
  );
};
export const VideoBadge: FunctionComponent = () => {
  return (
    <span
      style={{
        background:
          "linear-gradient(96deg, rgba(251, 251, 251, 0.14) -113.17%, rgba(251, 251, 251, 0.00) 100%)",
      }}
      className="flex items-center gap-1 backdrop-blur-sm px-3 py-3 border border-border rounded-full w-fit font-bold text-xs"
    >
      <YoutubeIcon className="w-4 h-4" />
      Youtube video
    </span>
  );
};

export const PendingApprovalBadge: FunctionComponent = () => {
  return (
    <span
      style={{ background: "rgba(255, 241, 54, 0.08)" }}
      className="flex items-center bg-documentsubmissiontext backdrop-blur-sm px-1 py-0.5 pr-3 border border-[#FFF136] rounded-full w-fit font-bold text-[#FFF136] text-xs"
    >
      <Dot />
      pending approval
    </span>
  );
};

export const ProcessingBadge: FunctionComponent = () => {
  return (
    <span className="flex items-center bg-rejectbuttonbg backdrop-blur-sm px-1 py-0.5 pr-3 border border-rejectbuttonborder rounded-full w-fit font-bold text-rejectbuttontext text-xs">
      <Dot />
      processing
    </span>
  );
};

export const CompletedBadge: FunctionComponent = () => {
  return (
    <span
      style={{ background: "rgba(150, 255, 67, 0.05)" }}
      className="flex items-center backdrop-blur-sm px-1 py-0.5 pr-3 border border-primarybuttonbg rounded-full w-fit font-bold text-primarybuttonbg text-xs"
    >
      <Dot />
      completed
    </span>
  );
};
